module.exports = __webpack_public_path__ + "media/assets/faria_products/MB_PASSPORT_logo-039b9e7307e9e01eccdac73632c901245973d654cca5ba069860c20ef21c4dbc.png";